export default [
    // {
    //     name: 'backgroundSound',
    //     type: 'audio',
    //     path: 'sounds/background.mp3'
    // },
    // {
    //     name: 'predatorModel',
    //     type: 'gltfModel',
    //     path: 'models/predator.glb'
    // },
    // {
    //     name: 'displacementTexture',
    //     type: 'texture',
    //     path: 'textures/displacement.jpg'
    // }

    {
        name: 'e2Model',
        type: 'gltfModel',
        path: 'models/e2.glb'
    },
    // {
    //     name: 'dnaModel',
    //     type: 'gltfModel',
    //     path: 'models/dna.glb'
    // },
    {
        name: 'boyModel',
        type: 'gltfModel',
        path: 'models/boy.glb'
    },
    {
        name: 'oniModel',
        type: 'gltfModel',
        path: 'models/oni.glb'
    },
    {
        name: 'horseModel',
        type: 'gltfModel',
        path: 'models/horse.glb'
    },
    {
        name: 'treeModel',
        type: 'gltfModel',
        path: 'models/tree.glb'
    },
]
